import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption } from '@angular/material/core';
import { CountryCode } from 'libphonenumber-js';
import { PropertyFormService } from '../../services/property-form.service';
import { Country } from '../../../../../shared/address/Country';
import { State } from '../../../../../shared/address/State';
import { formatPhoneNumber } from '../../../../../utilities/PhoneUtility';
import { UserContextProvider } from '../../../../../infrastructure/context/user-context-provider';

@Component({
  selector: 'property-form-homeowner',
  templateUrl: './property-form-homeowner.component.html',
  styleUrls: ['./property-form-homeowner.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIcon,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatOption,
    MatSelectModule,
    MatInputModule
  ]
})
export class PropertyFormHomeownerComponent implements OnInit {

  @Input() propertyFormService!: PropertyFormService;

  form!: FormGroup;
  countries!: Country[];
  states!: State[];
  panelOpen: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private userContextProvider: UserContextProvider
  ) { }

  ngOnInit(): void {
    this.propertyFormService.countries$.subscribe(countries => this.countries = countries);
    this.propertyFormService.states$.subscribe(states => this.states = states);

    this.form = this.formBuilder.group({
      address_id: [],
      country_id: [1],
      country_name: [''],
      city: [''],
      state: [''],
      address_line_1: [''],
      address_line_2: [''],
      postal_code: ['', Validators.pattern(/^\d+$/)],
      property_owner_name: ['', Validators.pattern(/[\S]/)],
      property_owner_email: ['', Validators.email],
      property_owner_phone: ['', Validators.pattern(/^[\s()+-]*([0-9][\s()+-]*){10,11}(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)]
    });

    this.propertyFormService.existingPropertyLoaded$.subscribe(state => {
      if(!state) {
        return;
      }
      
      this.form.patchValue({
        address_id: state.ownerAddressId,
        country_id: state.ownerAddressCountryId,
        country_name: state.ownerAddressCountryName,
        city: state.ownerAddressCity,
        state: state.ownerAddressState,
        address_line_1: state.ownerAddressLine1,
        address_line_2: state.ownerAddressLine2,
        postal_code: state.ownerAddressPostalCode,
        property_owner_name: state.ownerName,
        property_owner_email: state.ownerEmail,
        property_owner_phone: state.ownerPhone
      });

      this.form.markAllAsTouched();
      this.form.markAsDirty();
      this.propertyFormService.updateHomeownerState(this.form.value);
    });

    this.form.valueChanges.subscribe(state => this.updateStateAndFormValidity(state));
  }

  private updateStateAndFormValidity(state: any) {
    this.propertyFormService.updateHomeownerState(state);
    this.updateStepValidity();
  }

  private updateStepValidity() {
    this.propertyFormService.setHomeownerStepValidity(this.form.valid);
  }

  onPhoneNumberChanged(event: Event) {
    this.updatePhoneNumber((event.target as HTMLInputElement).value);
  }

  updatePhoneNumber(phoneNumber: string) {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber, this.userContextProvider.countryCode as CountryCode);
    this.form.patchValue({ property_owner_phone: formattedPhoneNumber });
  }
}